<app-header></app-header>

<div class="container main-page">
  <div class="row">
    <table class="table table-striped" style="text-align: center;">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">Report Name</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row">1</th>
          <td>Published Report</td>
          <td>
            <a routerLink="{{prefixReport}}/published-reports">View</a>
          </td>
        </tr>
        <tr>
          <th scope="row">2</th>
          <td>Dev My Title</td>
          <td>
            <a routerLink="{{prefixReport}}/dev-my-title"> View</a>
          </td>
        </tr>
        <tr>
          <th scope="row">3</th>
          <td>OSD Log</td>
          <td>
            <a routerLink="{{prefixReport}}/osd-log"> View</a>
          </td>
        </tr>
        <tr>
          <th scope="row">4</th>
          <td>PPD Dump</td>
          <td><a routerLink="{{prefixReport}}/ppd-dump"> View</a></td>
        </tr>
        <tr>
          <th scope="row">5</th>
          <td>Finance Royalty Rates V1</td>
          <td>
            <a routerLink="{{prefixReport}}/finance-royalty-rates-v1"> View</a>
          </td>
        </tr>
        <tr>
          <th scope="row">6</th>
          <td>Author Book Information</td>
          <td>
            <a routerLink="{{prefixReport}}/author-book-information"> View</a>
          </td>
        </tr>
        <tr>
          <th scope="row">7</th>
          <td>Contract Report for Bank Authors</td>
          <td>
            <a routerLink="{{prefixReport}}/contract-bank-authors"> View</a>
          </td>
        </tr>
        <tr>
          <th scope="row">8</th>
          <td>Derivative & it's Source Product</td>
          <td>
            <a routerLink="{{prefixReport}}/derivative-source-product"> View</a>
          </td>
        </tr>
        <tr>
          <th scope="row">9</th>
          <td>Finance Advance</td>
          <td><a routerLink="{{prefixReport}}/finance-advances"> View</a></td>
        </tr>
        <tr>
          <th scope="row">10</th>
          <td>Total Royalty by Product</td>
          <td>
            <a routerLink="{{prefixReport}}/total-royalty-product"> View</a>
          </td>
        </tr>
        <tr>
          <th scope="row">11</th>
          <td>Finance Royalty Rates V2</td>
          <td>
            <a routerLink="{{prefixReport}}/finance-royalty-rates-v2"> View</a>
          </td>
        </tr>
        <tr>
          <th scope="row">12</th>
          <td>Exchange Rates</td>
          <td><a routerLink="{{prefixReport}}/exchange-rates"> View</a></td>
        </tr>
        <tr>
          <th scope="row">13</th>
          <td>Timesheet</td>
          <td><a routerLink="{{prefixReport}}/timesheet"> View</a></td>
        </tr>
        <tr>
          <th scope="row">14</th>
          <td>Pipeline Info</td>
          <td><a routerLink="{{prefixReport}}/pipeline-info"> View</a></td>
        </tr>
        <tr>
          <th scope="row">15</th>
          <td>Author Advances -Invoice Generated</td>
          <td>
            <a routerLink="{{prefixReport}}/author-advance-invoice-generate">
              View</a
            >
          </td>
        </tr>
        <tr>
          <th scope="row">16</th>
          <td>Authors EmailId</td>
          <td><a routerLink="{{prefixReport}}/authors-emailid"> View</a></td>
        </tr>
        <tr>
          <th scope="row">17</th>
          <td>Dev FD Pending Acceptance</td>
          <td>
            <a routerLink="{{prefixReport}}/dev-fd-pending-acceptance"> View</a>
          </td>
        </tr>
        <tr>
          <th scope="row">18</th>
          <td>Titles Published</td>
          <td><a routerLink="{{prefixReport}}/titles-published"> View</a></td>
        </tr>
        <tr>
          <th scope="row">19</th>
          <td>Titles In Production</td>
          <td>
            <a routerLink="{{prefixReport}}/titles-in-production"> View</a>
          </td>
        </tr>
        <tr>
          <th scope="row">20</th>
          <td>Chapterwise Titles In Production</td>
          <td>
            <a routerLink="{{prefixReport}}/chapterwise-titles-production">
              View</a
            >
          </td>
        </tr>
        <tr>
          <th scope="row">21</th>
          <td>Accounts Master New</td>
          <td>
            <a routerLink="{{prefixReport}}/accounts-master-new"> View</a>
          </td>
        </tr>
        <tr>
          <th scope="row">22</th>
          <td>PPD Dump New</td>
          <td><a routerLink="{{prefixReport}}/ppd-dump-new"> View</a></td>
        </tr>
        <tr>
          <th scope="row">23</th>
          <td>Author Book Information New</td>
          <td>
            <a routerLink="{{prefixReport}}/author-book-info-new"> View</a>
          </td>
        </tr>
        <tr>
          <th scope="row">24</th>
          <td>OSD Log New</td>
          <td><a routerLink="{{prefixReport}}/osd-log-new"> View</a></td>
        </tr>
        <tr>
          <th scope="row">25</th>
          <td>Author Information</td>
          <td><a routerLink="{{prefixReport}}/author-information"> View</a></td>
        </tr>
        <tr>
          <th scope="row">26</th>
          <td>Announced and Contracted Date</td>
          <td>
            <a routerLink="{{prefixReport}}/announced-contracted"> View</a>
          </td>
        </tr>
        <tr>
          <th scope="row">27</th>
          <td>Trade Sale</td>
          <td><a routerLink="{{prefixReport}}/trade-sale"> View</a></td>
        </tr>
        <tr>
          <th scope="row">28</th>
          <td>Source and Derivative Product Relationship</td>
          <td><a routerLink="{{prefixReport}}/source-derivative-product-rel"> View</a></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
